import {
  ReportingImportRowPayload,
  ReportingImportRowStatus,
  ReportingImportRowStepStatuses,
  ReportingImportValidationError,
} from '../reporting/reporting-import.model';

export enum LoadReportingImportNormalizationStepQualityRequestKeys {
  runId = 'runId',
  uploadActionId = 'uploadActionId',
  loadOptions = 'loadOptions',
}

export interface LoadReportingImportNormalizationStepQualityRequest {
  [LoadReportingImportNormalizationStepQualityRequestKeys.runId]?: string | null;
  [LoadReportingImportNormalizationStepQualityRequestKeys.uploadActionId]?: string | null;
  [LoadReportingImportNormalizationStepQualityRequestKeys.loadOptions]?: Record<string, unknown> | null;
}

export interface ReportingImportNormalizationStepQuality {
  rowNumber: number;
  status: ReportingImportRowStatus | string;
  needsUserInput: boolean;
  isUserResolved: boolean;
  includedInFinal: boolean;
  validationErrorsCount: number;
  validationErrors: ReportingImportValidationError[];
  normalizationStepStatuses: ReportingImportRowStepStatuses;
  payloadSource: 'final' | 'corrected' | 'normalized' | 'raw' | 'none';
  payload: ReportingImportRowPayload | null;
}

export interface LoadReportingImportNormalizationStepQualityResponse {
  rows: ReportingImportNormalizationStepQuality[];
  totalCount: number;
}
